export default `
  #graphql
  fragment CartItemFields on ProductInterface {
    __typename
    id
    uid
    sku
    stock_status
    name
    manufacturer
    bestseller
    recommended
    special_price
    main_category
    delivery_time

    categories {
      id
      name
      level
      path
    }
    stock_item {
      qty_increments
      min_sale_qty
      max_sale_qty
    }
    thumbnail {
      url
    }
    crosssell_products {
      sku
    }
  }
`;
